export class BaseComponent {
    config;
    constructor(config) {
        this.config = config;
    }
    addTo(config, update = false) {
        config[update ? "updateComponent" : "addComponent"](this);
        return this;
    }
}
export class EsphomeComponent extends BaseComponent {
    constructor(config) {
        super(config);
    }
    synth() {
        let parts = this.componentName.split('.');
        if (parts.length == 1) {
            return [{ _domain: parts[0], ...this.config }];
        }
        return [{
                _domain: parts[1],
                platform: parts[0],
                ...this.config
            }];
    }
}
export class VirtualComponent extends BaseComponent {
    componentName = "virtual";
}
